import FieldController from '../field.controller';

class NumericFieldController extends FieldController {

  _clearPhoneFormatting() {
    return this.value.replaceAll(/[\+\(\)\-\s]/g, '');
  }

  _maskValue() {
    let val = this._clearPhoneFormatting();
    if (val && val.length > 10) {
      // Phone number is too long, trim it down
      val = val.substring(0, 10);
    }
    if (val && val.length) {
      // Fill in the mask
      let maskedVal = '(';
      for (let i = 0; i < val.length; i++) {
        maskedVal += val.charAt(i);
        const nextExists = i + 1 < val.length;
        if (nextExists) {
          if (i === 2) {
            maskedVal += ') ';
          } else if (i === 5) {
            maskedVal += '-';
          }
        }
      }
      return maskedVal;
    } else {
      // Empty value
      val = '';
    }
    return val;
  }

  $onInit() {
    this.$scope.$watch(
      () => this.value,
      (newVal, oldVal) => {
        if (newVal !== oldVal) {
          this.$timeout(() => {
            this.value = this._maskValue();
          });
        }
      }
    )
    return super.$onInit();
  }
}

export default NumericFieldController;
